import { FC, ReactNode } from 'react'
import clsx from 'clsx'

import Loader from 'components/parts/loader/loader'
import styles from '../translation-player.module.scss'

const LOADING_TEXT = 'Видео загружается. Проверьте интернет соединение'

interface ITranslationPlayer {
  isFullScreen: boolean
  dimension: object
  isPC: boolean
  isVerticalOrientation: boolean
  fakeContainerRef: React.RefObject<HTMLDivElement>
  containerRef: React.RefObject<HTMLDivElement>
  children: ReactNode
  isFirstLoaded?: boolean
  isVideoBugScreen?: boolean
}

const TranslationPlayer: FC<ITranslationPlayer> = ({
  isFullScreen,
  dimension,
  isPC,
  isVerticalOrientation,
  isVideoBugScreen,
  isFirstLoaded,
  fakeContainerRef,
  containerRef,
  children,
}) => {
  return (
    <>
      <div
        className={clsx(styles.iframeContainer, {
          [styles.iframeContainerFullScreen]: isFullScreen,
        })}
        ref={containerRef}
      >
        <div
          className={clsx(styles.fakeContainer, {
            [styles.PCfakeContainer]: isPC,
            [styles.MobileVerticalFakeContainer]: !isPC && isVerticalOrientation,
            [styles.MobileHorizontalFakeContainer]: !isPC && !isVerticalOrientation,
            [styles.MobileFullScreenFakeContainer]: !isPC && isFullScreen,
          })}
          style={isFirstLoaded ? {} : dimension}
          ref={fakeContainerRef}
        >
          <div className={clsx(styles.fallback, { [styles.fallbackBug]: isVideoBugScreen })}>
            {isVideoBugScreen && LOADING_TEXT}
            <div className={styles.loader}>
              <Loader />
            </div>
          </div>
          {children}
        </div>
      </div>
    </>
  )
}

export default TranslationPlayer
